import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AirportPageComponent } from '../airport/airport-page/airport-page.component';
import { AirportDetailComponent } from '../airport/airport-detail/airport-detail.component';
import { ActivityDetailComponent } from '../airport/activity-detail/activity-detail.component';
import { AirportResolver } from './resolvers/airport-resolver.service';
import { ExternalUrlResolver } from './resolvers/external-url-resolver.service';
import { NotFoundComponent } from '../shared/not-found/not-found.component';
import { ErrorComponent } from '../shared/error/error.component';
import { BusinessResolver } from './resolvers/business-resolver.service';
import { BusinessPageComponent } from '../business/business-page/business-page.component';
import { LandingPageComponent } from '../search/landing-page/landing-page.component';
import { SearchPageComponent } from '../search/search-page/search-page.component';
import { StateResolver } from './resolvers/state-resolver.service';
import { StateListingComponent } from '../search/state-listing/state-listing.component';
import { StateAirportsComponent } from '../search/state-airports/state-airports.component';
import { FlyingclubPageComponent } from '../business/flyingclub-page/flyingclub-page.component';
import { CanDeactivateGuardService } from '../shared/services/can-deactivate-guard.service';
import { EditBusinessHoursComponent } from '../business/edit-business-hours/edit-business-hours.component';
import { AirportIslandDetailComponent } from '../airport/airport-island-detail/airport-island-detail.component';
import { EventResolver } from './resolvers/event-resolver.service';
import { EventPageComponent } from '../event/event-page/event-page.component';
import {EventAddFormComponent} from '../event/event-add-form/event-add-form.component';

const routes: Routes = [
  { path: '', component: LandingPageComponent },
  {
    path: 'search',
    component: SearchPageComponent
  },
  {
    path: 'airports/state',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: StateListingComponent,
      },
      {
        path: ':state',
        component: StateAirportsComponent,
        resolve: {
          state: StateResolver
        }
      }
    ]
  },
  {
    path: 'airports/:id',
    component: AirportPageComponent,
    resolve: {
      airport: AirportResolver
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'details'
      },
      {
        path: 'details',
        component: AirportDetailComponent
      },
      {
        path: 'activities',
        component: ActivityDetailComponent
      },
      {
        path: 'island',
        component: AirportIslandDetailComponent
      }
    ]
  },
  {
    path: 'business/:id',
    component: BusinessPageComponent,
    resolve: {
      business: BusinessResolver
    },
    children: [
      {
        path: '',
        component: EditBusinessHoursComponent,
        canDeactivate: [CanDeactivateGuardService]
      }
    ]
  },
  {
    path: 'flyingclub/:id',
    component: FlyingclubPageComponent,
    resolve: {
      business: BusinessResolver
    }
  },
  {
    path: 'event/:id',
    component: EventPageComponent,
    resolve: {
      aviationEvent: EventResolver
    }
  },
  {
    path: 'addevent',
    component: EventAddFormComponent,
  },
  { path: '404', component: NotFoundComponent },
  { path: '500', component: ErrorComponent },
  { path: '**', component: NotFoundComponent }
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AirportResolver,
    BusinessResolver,
    ExternalUrlResolver,
    StateResolver
  ]
})
export class AppRoutingModule { }
